// symptomHelper.js

export const saveSymptoms = (symptoms) => {
    localStorage.setItem('symptoms', symptoms);
  };
  
  export const getSymptoms = () => {
    return localStorage.getItem('symptoms');
  };
  